import React, { useState, useEffect } from 'react';

export default function QRCodeImg({ url, size = 96 }) {
  const [dataUrl, setDataUrl] = useState(null);
  useEffect(() => {
    let cancelled = false;
    import('qrcode').then(QRCode => {
      QRCode.default.toDataURL(url, { width: size, margin: 1 }).then(d => {
        if (!cancelled) setDataUrl(d);
      });
    }).catch(() => {});
    return () => { cancelled = true; };
  }, [url, size]);
  if (!dataUrl) return null;
  return <img src={dataUrl} alt="QR code" width={size} height={size} className="ro-qr" />;
}
